import React from 'react';

import { styled } from 'twin.macro';

import { Modal } from '@/components/Modal';
import UvAuth from '@/core/auth/UvAuth';

export type Props = {
  open: boolean;
  onClose?: () => void;
  onSignIn?: () => void;
};

const RainbowBorder = styled.div`
  background: linear-gradient(85.94deg, #009CDE 3.16%, #963CBD 62.12%, #FF6720 113.51%);
  height: 2px;
`;

export function LoginModal({ open, onClose, onSignIn }: Props) {

  return (
    <Modal
      className="flex items-center justify-center w-full p-10 pt-12"
      open={open}
      onClose={onClose}
      style={{ maxWidth: 400 }}
    >
      <>
        <RainbowBorder className="absolute top-0 w-full" />
        <UvAuth mode="frameless" className="w-full h-full" subheading="We need you to sign in to continue!" onSignIn={onSignIn} />
      </>
    </Modal>
  );
}
